import { ComponentStyleConfig } from '@chakra-ui/theme';

// see https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/checkbox.ts
// for default ChakraUI theme
export const RadioTheme: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: 'blue',
  },
};
